import { apiClient } from './client';
export const touchPointsApi = {
    // Get all touchpoints for a specific web (optionally filtered by types)
    getTouchPointsByWeb: (workspaceId, webId, types) => {
        const url = types && types.length > 0
            ? `/api/Workspaces/${workspaceId}/Webs/${webId}/TouchPoints?types=${types.join(',')}`
            : `/api/Workspaces/${workspaceId}/Webs/${webId}/TouchPoints`;
        return apiClient.get(url);
    },
    // Get all touchpoints for a specific campaign (optionally filtered by types)
    getTouchPointsByCampaign: (workspaceId, campaignId, types) => {
        const url = types && types.length > 0
            ? `/api/Workspaces/${workspaceId}/Campaigns/${campaignId}/TouchPoints?types=${types.join(',')}`
            : `/api/Workspaces/${workspaceId}/Campaigns/${campaignId}/TouchPoints`;
        return apiClient.get(url);
    },
    // Create a new touchpoint (with optional file upload for meetings)
    createTouchPoint: (workspaceId, dto, file) => {
        if (file) {
            const formData = new FormData();
            formData.append('touchPointData', JSON.stringify(dto));
            formData.append('file', file);
            return apiClient.post(`/api/Workspaces/${workspaceId}/TouchPoints`, formData);
        }
        return apiClient.post(`/api/Workspaces/${workspaceId}/TouchPoints`, dto);
    },
    // Update an existing touchpoint (with optional file upload for meetings)
    updateTouchPoint: (workspaceId, id, dto, file) => {
        if (file) {
            const formData = new FormData();
            formData.append('touchPointData', JSON.stringify(dto));
            formData.append('file', file);
            return apiClient.put(`/api/Workspaces/${workspaceId}/TouchPoints/${id}`, formData);
        }
        return apiClient.put(`/api/Workspaces/${workspaceId}/TouchPoints/${id}`, dto);
    },
    // Patch touchpoint schedule (for calendar drag-and-drop on non-email touchpoints)
    patchSchedule: (workspaceId, id, dto) => apiClient.request(`/api/Workspaces/${workspaceId}/TouchPoints/${id}/Schedule`, { method: 'PATCH', body: dto }),
    // Patch email touchpoint rule (replaces the inline send-time concept for email touchpoints)
    patchRule: (workspaceId, id, dto) => apiClient.request(`/api/Workspaces/${workspaceId}/TouchPoints/${id}/Rule`, { method: 'PATCH', body: dto }),
    // Delete a touchpoint
    deleteTouchPoint: (workspaceId, id) => apiClient.delete(`/api/Workspaces/${workspaceId}/TouchPoints/${id}`)
};
